export const CHEQUING_TABLES = {
    INCOME: 'Income Summary',
    EXPENSE: 'Expense Summary',
    SAVING: 'Saving Summary',
};
